import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { BaseComponent } from '@carm/_utils/base.component';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '@carm/_auth/spartacus/core/auth';

@Component({
  selector: 'carm-main-header-top-section',
  templateUrl: './main-header-top-section.component.html',
  styleUrls: ['./main-header-top-section.component.scss'],
})
export class MainHeaderTopSectionComponent extends BaseComponent implements OnInit, OnDestroy {
  gcLogo: string;
  isLoggedIn$: Observable<boolean>;

  constructor(
    @Inject(LOCALE_ID) public localeId: string,
    private authService: AuthService,
    private sanitizer: DomSanitizer) {

    super();

    this.localeReqs(localeId);
  }

  localeReqs(locale: string) {
    this.gcLogo = `assets/themes-dist-10.5.2-gcweb/GCWeb/assets/sig-blk-${locale}.svg`;
  }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isUserLoggedIn().pipe(takeUntil(this.destroy$));
  }

  search(searchValue: string) {
    // Sanitize the searchValue before appending it to the URL
    const sanitizedSearchValue = this.sanitizer.sanitize(SecurityContext.URL, searchValue);

    const queryParams = new URLSearchParams()
    queryParams.set('q', sanitizedSearchValue);


    location.href = `https://www.canada.ca/${this.localeId}/sr/srb.html?cdn=canada&st=s&num=10&st1rt=1&s5bm3ts21rch=x&_charset_=UTF-8&wb-srch-sub=&${queryParams.toString()}`
  }
}
